import { useQuery } from '@apollo/client'
import { useAuth } from 'context/AuthProvider'

import { atlasClient } from 'graphql/client'

import { GET_UNREAD_MESSAGES_COUNT } from './messageMenuOption.queries'

export const useUnreadMessagesCount = () => {
  const { isAuthenticated } = useAuth()
  const { data } = useQuery(GET_UNREAD_MESSAGES_COUNT, {
    client: atlasClient,
    skip: !isAuthenticated,
  })
  return {
    unreadMessagesCount: data?.unreadMessageCount?.count ?? 0,
  }
}
